import { useTranslation } from "react-i18next";
import { useState } from "react";
import clsx from "clsx";

import classes from "./styles.module.scss";

import type { INoShowTypes } from "@api/appointment";
import { useNoShowAppointment } from "@api/appointment";
import { Checkbox } from "@components/atoms/checkbox";
import { notify } from "@components/atoms/notify";
import { useNotifyPromise } from "@hooks";
import { closeAlert } from "@/stores/uiStore";
import { ActionAlertButtons } from "@components/molecules/alert/actionAlertButtons";
import type { INoShowOptionsProps } from "@components/organisms/appointmentCard/components/appointmentHelper/types";

export function NoShowOptions({ id }: INoShowOptionsProps) {
  const { t } = useTranslation("form");

  const notifyMutate = useNotifyPromise();
  const { mutateAsync, isLoading } = useNoShowAppointment();

  const [noShow, setNoShow] = useState<INoShowTypes | "">("");

  return (
    <>
      <div className={clsx(classes.noShow)}>
        <Checkbox
          title={t("option-doctor-cancel")}
          onChange={() => {
            setNoShow("doctor-no-show");
          }}
          value={noShow === "doctor-no-show"}
        />
        <Checkbox
          title={t("option-patient-cancel")}
          onChange={() => {
            setNoShow("patient-no-show");
          }}
          value={noShow === "patient-no-show"}
        />
        <Checkbox
          title={t("system-caused-no-show")}
          onChange={() => {
            setNoShow("system-caused-no-show");
          }}
          value={noShow === "system-caused-no-show"}
        />
        {/* <Checkbox
          title={t('doctor-denied-no-show')}
          onChange={() => {
            setNoShow('doctor-denied-no-show')
          }}
          value={noShow === 'doctor-denied-no-show'}
        />*/}
      </div>
      <div className={clsx(classes.noShow__buttons)}>
        <ActionAlertButtons
          isLoading={isLoading}
          onClose={() => {
            setNoShow("");
          }}
          onCancel={() => {
            setNoShow("");
            closeAlert();
          }}
          approveTitle={t("submit")}
          setIsLoading={() => {}}
          onApprove={() => {
            if (!noShow) {
              notify.error({ text: t("must_select_no_show") });
              return;
            }
            notifyMutate(
              mutateAsync(
                { appointmentId: id, no_show_cause: noShow },
                {
                  onSuccess: () => {
                    closeAlert();
                    setNoShow("");
                  },
                },
              ),
            );
          }}
        />
      </div>
    </>
  );
}
